import { render, staticRenderFns } from "./ReviewStatus.vue?vue&type=template&id=d72e1d78&"
import script from "./ReviewStatus.vue?vue&type=script&lang=js&"
export * from "./ReviewStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports